<template>
	<div>
		<h3 class="g-facet-set__heading" @click="section.collapse = !section.collapse">
			<button class="g-facet-set__label g-button--no-styling">
				{{section.label}}
			</button>
		</h3>
		<div class="g-facet-set__list">
			<div class="g-facet-set__list-item g-form-checkbox" v-for="category in section.category.slice(0, section.overflow.limit)" :key="category.id">
				<a class="g-facet-set__list-item-link" :href="category.uri">
					<span class="g-facet-set__list-item-name" :class="{'g-facet-set__list-item-name--applied': category.code === activeCategoryCode}" v-html="category.name"></span>
				</a>
			</div>
			<div class="g-facet-view-more" v-if="( section.category.length > section.overflow.limit )">
				<input :id="'g-facet-view-more__' + section.label" class="g-facet-view-more__checkbox u-hide-visually" type="checkbox" @change="viewMoreChange">
				<label class="g-facet-view-more__label" :for="'g-facet-view-more__' + section.label">View More</label>
				<div class="g-facet-view-more__content">
					<div class="g-facet-set__list-item g-form-checkbox" v-for="category in section.category.slice(section.overflow.limit, section.category.length)" :key="category.id">
						<a class="g-facet-set__list-item-link" :href="category.uri">
							<span class="g-facet-set__list-item-name" :class="{'g-facet-set__list-item-name--applied': category.code === activeCategoryCode}" v-html="category.name"></span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				baseURL: mivaJS.Storefront_Url.replace(/\/+$/, '')
			}
		},
		props: {
			activeCategoryCode: {
				default() {
					return null;
				}
			},
			section: {
				default() {
					return [];
				}
			}
		},
		methods: {
			toggleFilter ( field, value ) {

				Search.client.filter( field, value ).search();

			},
			viewMoreChange(event) {

				if(event.target.checked) {
					event.target.nextElementSibling.innerText = 'View Less';
				} else {
					event.target.nextElementSibling.innerText = 'View More';
				}

			}
		}
	}

</script>
